import {useState, useEffect, useContext, useMemo} from 'react';
import { useNavigate } from 'react-router-dom';
import { H2, Panel, Flex, FlexItem, Button, Text, Box, Table } from '@bigcommerce/big-design';
import { AddIcon, EditIcon, AssignmentIcon, DeleteIcon } from '@bigcommerce/big-design-icons';
import Container from '../../ui/Container';
import AppContext from '../../AppContext';

export default function Events() {

    const { user_token, store_hash } = useContext(AppContext);

    const [isLoading, setIsLoading] = useState(false);
    const [events, setEvents] = useState([]);

    const [isOpen, setIsOpen] = useState(false);
    const [sorted, setSorted] = useState(false);
    const [localFields, setLocalFields] = useState(events);

    const navigate = useNavigate();
    const handleEdit = (id) => {
        navigate(`/events/${id}`);
    };
    const viewAttendees = (id) => {
        const name = events.find(e => e.id === id).name;
        navigate(`/events/${id}/attendees?name=${name}`);
    };


    useEffect(() => {
        getEvents();
        console.log('Events');
    }, []);

    const getEvents = () => {
        console.log('Get Events');
        fetch(`${process.env.REACT_APP_API_URL}/events/getEventProducts?signed_payload=${user_token}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json())
        .then(data => {
            console.log("data", data);
            setEvents(data);
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    };

    const handleDelete = async (fieldId) => {
        console.log('delete field', fieldId);
        fetch(`${process.env.REACT_APP_API_URL}/events/deleteEventProduct?signed_payload=${user_token}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'User-Token': user_token,
            },
            body: JSON.stringify({
                productId: fieldId,
            }),
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response;
        })
        .then(data => {
            let tempFields = [...events];
            let index = tempFields.findIndex(f => f.id === fieldId);
            tempFields.splice(index, 1);
            setEvents(tempFields);            
        })
        .catch(err => {
            console.log(err);
        });
    };

    return (
        <Container className="checkout">
            {!isLoading &&
                <Box>
                    <Flex justifyContent="space-between">
                        <FlexItem>
                            <H2>Events</H2>
                        </FlexItem>
                        <FlexItem>
                        <Button onClick={() => handleEdit('new')} variant='secondary' iconLeft={<AddIcon />}>
                            New Event
                        </Button>
                        </FlexItem>
                    </Flex>
                    <Panel marginTop={'large'}>
                    {events && events.length > 0 ? <Table
                            columns={[
                                { header: 'Name', hash: 'name', render: ({ name }) => name },
                                { header: 'Attendees', hash: 'attendees', render: ({ id }) => {
                                    return (
                                        <>
                                            <Button onClick={() => viewAttendees(id)} variant='subtle' iconOnly={<AssignmentIcon title="view attendees" />}></Button>
                                        </>
                                    )
                                } },
                                { header: 'Actions', hash: 'actions', align: 'right', render: ({ id }) => {
                                    return (
                                        <Flex>
                                             <FlexItem><Button onClick={() => handleEdit(id)} variant='subtle' iconOnly={<EditIcon title="edit" />}></Button></FlexItem>
                                             <FlexItem><Button onClick={() => handleDelete(id)} variant='subtle' iconOnly={<DeleteIcon title="delete" />}></Button></FlexItem>
                                        </Flex>
                                    )} },
                            ]}
                            items={events}
                            key={`_table`}
                        /> : null}
                    </Panel>
                    
                </Box>
            }
        </Container>
    );
}
